// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1164":"0e1a32f7","5546":"539ad024","9322":"4633a33f"}[chunkId] + ".chunk.css";
};